import SvgPreview from "components/features/svgOne";
import styled from "styled-components";

const SvgOne = () => (
  <svg width="47" height="48" viewBox="0 0 47 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.775391" width="20.7839" height="20.7839" rx="2.36181" fill="#B8C3E9" />
    <rect y="26.9922" width="20.7839" height="20.7839" rx="2.36181" fill="#6C8EF8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.6132 26.9922C33.9692 26.9922 32.6365 28.3249 32.6365 29.9689V34.4079L28.1984 34.4079C26.5544 34.4079 25.2217 35.7406 25.2217 37.3846C25.2217 39.0286 26.5544 40.3613 28.1984 40.3613H32.6365V44.7994C32.6365 46.4434 33.9692 47.7761 35.6132 47.7761C37.2572 47.7761 38.5899 46.4434 38.5899 44.7994V40.3613H43.0289C44.6729 40.3613 46.0056 39.0286 46.0056 37.3846C46.0056 35.7406 44.6729 34.4079 43.0289 34.4079L38.5899 34.4079V29.9689C38.5899 28.3249 37.2572 26.9922 35.6132 26.9922Z"
      fill="#B8C3E9"
    />
    <rect x="25.2227" y="0.775391" width="20.7839" height="20.7839" rx="2.36181" fill="#6C8EF8" />
  </svg>
);
const SvgThree = () => (
  <svg width="53" height="41" viewBox="0 0 53 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.1594 0.363282C31.7378 0.363282 33.2516 0.999663 34.3677 2.13243C35.4838 3.26519 36.1108 4.80155 36.1108 6.40352L6.35376 6.40352L6.35376 30.5645C4.77534 30.5645 3.26158 29.9281 2.14547 28.7953C1.02937 27.6626 0.402344 26.1262 0.402344 24.5242L0.402345 6.40352C0.402345 4.80155 1.02937 3.26519 2.14547 2.13243C3.26158 0.999661 4.77534 0.363281 6.35376 0.363281L30.1594 0.363282Z"
      fill="#B8C3E9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5488 10.7363C13.589 10.7363 12.6684 11.1176 11.9897 11.7964C11.311 12.4751 10.9297 13.3956 10.9297 14.3555V37.2124C10.9297 38.1722 11.311 39.0928 11.9897 39.7715C12.6684 40.4502 13.589 40.8315 14.5488 40.8315H48.7437C49.7035 40.8315 50.6241 40.4502 51.3028 39.7715C51.9815 39.0928 52.3628 38.1722 52.3628 37.2124V14.3555C52.3628 13.3956 51.9815 12.4751 51.3028 11.7964C50.6241 11.1176 49.7035 10.7363 48.7437 10.7363H14.5488ZM48.7437 37.2124H14.5488L25.9131 17.9746L35.9518 33.5932L42.0669 21.5938L48.7437 37.2124Z"
      fill="#6C8EF8"
    />
  </svg>
);
const SvgBlobs = ({ className }) => (
  <svg
    className={className}
    width="191"
    height="122"
    viewBox="0 0 191 122"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="paint0blobs" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop stopColor="#9D7DE9" />
        <stop offset="1" stopColor="#6890FA" />
      </linearGradient>
    </defs>
    <circle cx="127.023" cy="14.8086" r="11.8105" fill="url(#paint0blobs)" />
    <circle cx="152.788" cy="83.8111" r="37.5748" fill="url(#paint0blobs)" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M149.454 71.3514C147.764 71.3514 146.143 72.0227 144.948 73.2176C143.753 74.4125 143.082 76.0332 143.082 77.7231V86.2188C143.082 89.0353 144.201 91.7364 146.192 93.728C148.184 95.7195 150.885 96.8384 153.701 96.8384C156.518 96.8384 159.219 95.7195 161.211 93.728C163.202 91.7364 164.321 89.0353 164.321 86.2188V77.7231C164.321 77.1598 164.545 76.6196 164.943 76.2213C165.341 75.823 165.882 75.5992 166.445 75.5992C167.008 75.5992 167.548 75.823 167.947 76.2213C168.345 76.6196 168.569 77.1598 168.569 77.7231V86.2188C168.569 88.1712 168.184 90.1045 167.437 91.9083C166.69 93.7121 165.595 95.3511 164.214 96.7316C162.834 98.1122 161.195 99.2073 159.391 99.9545C157.587 100.702 155.654 101.086 153.701 101.086C151.749 101.086 149.816 100.702 148.012 99.9545C146.208 99.2073 144.569 98.1122 143.189 96.7316C141.808 95.3511 140.713 93.7121 139.966 91.9083C139.219 90.1045 138.834 88.1712 138.834 86.2188V77.7231C138.834 74.9066 139.953 72.2055 141.944 70.2139C143.936 68.2224 146.637 67.1035 149.454 67.1035C152.27 67.1035 154.971 68.2224 156.963 70.2139C158.954 72.2055 160.073 74.9066 160.073 77.7231V86.2188C160.073 87.9087 159.402 89.5294 158.207 90.7243C157.012 91.9192 155.391 92.5905 153.701 92.5905C152.012 92.5905 150.391 91.9192 149.196 90.7243C148.001 89.5294 147.33 87.9087 147.33 86.2188V77.7231C147.33 77.1598 147.553 76.6196 147.952 76.2213C148.35 75.823 148.89 75.5992 149.454 75.5992C150.017 75.5992 150.557 75.823 150.955 76.2213C151.354 76.6196 151.577 77.1598 151.577 77.7231V86.2188C151.577 86.7821 151.801 87.3223 152.2 87.7206C152.598 88.1189 153.138 88.3427 153.701 88.3427C154.265 88.3427 154.805 88.1189 155.203 87.7206C155.602 87.3223 155.825 86.7821 155.825 86.2188V77.7231C155.825 76.0332 155.154 74.4125 153.959 73.2176C152.764 72.0227 151.143 71.3514 149.454 71.3514Z"
      fill="#DEDEDE"
    />
    <circle cx="51.4994" cy="51.0658" r="50.7143" fill="url(#paint0blobs)" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.0056 28.5779C24.7515 29.8321 24.0469 31.5331 24.0469 33.3068V46.682C24.0469 48.4557 24.7515 50.1567 26.0056 51.4109C27.2598 52.665 28.9608 53.3696 30.7345 53.3696H37.4221V63.401L47.4535 53.3696H54.1412C55.9148 53.3696 57.6158 52.665 58.87 51.4109C60.1242 50.1567 60.8288 48.4557 60.8288 46.682V33.3068C60.8288 31.5331 60.1242 29.8321 58.87 28.5779C57.6158 27.3237 55.9148 26.6191 54.1412 26.6191H30.7345C28.9608 26.6191 27.2598 27.3237 26.0056 28.5779ZM67.5169 46.679V39.9914H70.8607C72.6344 39.9914 74.3354 40.696 75.5896 41.9501C76.8437 43.2043 77.5483 44.9053 77.5483 46.679V60.0542C77.5483 61.8279 76.8437 63.5289 75.5896 64.7831C74.3354 66.0373 72.6344 66.7419 70.8607 66.7419H64.1731V76.7733L54.1417 66.7419H47.454C46.3205 66.7419 45.2538 66.461 44.3175 65.9627L50.2227 60.0542H54.1417C57.689 60.0542 61.091 58.6451 63.5994 56.1367C66.1077 53.6284 67.5169 50.2263 67.5169 46.679Z"
      fill="#DEDEDE"
    />
  </svg>
);
const StyledBlobs = styled(SvgBlobs)`
  position: absolute;
  right: -1rem;
  top: -1rem;
  height: 75px;
  width: auto;
`;
const StyledPreview = styled(SvgPreview)`
  width: 100%;
  height: auto;
  @media screen and (max-width: 768px) {
    margin-bottom: 1rem;
  }
`;

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 2rem 2rem 2rem;
  position: relative;
  z-index: 2;
  margin-bottom: 2rem;
  @media screen and (max-width: 992px) {
    padding: 1rem 2rem;
  }
  @media screen and (max-width: 768px) {
    padding: 0 2rem;
    margin-top: 2rem;
  }
`;
const StyledContainer = styled.div`
  max-width: 1280px;
  width: 100%;
  display: flex;
  align-items: center;
  h2 {
    line-height: 4rem;
    font-size: 3.375rem;
    font-weight: 700;
    @media screen and (max-width: 1280px) {
      margin: 2rem 0 0 0;
    }
    @media screen and (max-width: 992px) {
      line-height: 4.2rem;
      font-size: 3rem;
    }
  }
  p {
    font-size: 1.2rem;
    line-height: 2rem;
  }
  @media screen and (max-width: 992px) {
    flex-direction: column;
  }
  > div {
    flex: 1 1 50%;
  }
`;
const StyledRight = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  padding: 0 2rem;
`;

const StyledBlock = styled.div`
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 1rem;
  flex: 1;
  svg {
    max-width: 100%;
    margin-bottom: 1.5rem;
  }
`;
const StyledContent = styled.div`
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  align-items: ${(props) => props.center && "center"};
  text-align: ${(props) => props.center && "center"};
  > div {
    margin-bottom: 1rem;
  }
`;
const StyledLabel = styled.div`
  font-weight: 700;
  font-size: 1.4rem;
`;

const Features = () => {
  return (
    <StyledWrapper>
      <StyledContainer>
        <div>
          <StyledBlock>
            <StyledContent>
              <SvgOne />
              <StyledLabel>Delete from 30+ services</StyledLabel>
              <div>
                Delete your old data from all of your most-used services, including Discord, Reddit,
                Twitter, Facebook, and more!
              </div>
            </StyledContent>
          </StyledBlock>
          <StyledBlock>
            <StyledContent>
              <SvgThree />
              <StyledLabel>Delete all types of content</StyledLabel>
              <div>
                Delete your posts, DMs, photos, videos, likes, and other unique content in other
                services.
              </div>
            </StyledContent>
          </StyledBlock>
        </div>
        <StyledRight>
          <StyledPreview />
          <StyledBlobs />
        </StyledRight>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Features;
